import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const NAVIGATION_SEARCH_PARAM = "navigation";

const NAVIGATION_PAGE_SIZE = 100;
const NAVIGATION_REQUESTS_LIMIT = 10;

const useEntityNavigationHandle = (
    url: string,
    searchParams: URLSearchParams,
    updateFlagNavigationCallback: React.Dispatch<React.SetStateAction<boolean>>,
    entityNumber: string,
    entityCurrentIndex: number | null |undefined,
    navigationPageSize: number = NAVIGATION_PAGE_SIZE,
    navigationRequestsLimit: number = NAVIGATION_REQUESTS_LIMIT,
    navigationSearchParam: string = NAVIGATION_SEARCH_PARAM
) => {
  const history = useHistory();

  useEffect(() => {
    const currentIndex = Math.floor((entityCurrentIndex ?? 0) / navigationPageSize);
    if ((currentIndex > navigationRequestsLimit) || entityCurrentIndex === null) {
      updateFlagNavigationCallback((prev) => {
        if (!prev) return prev; // if false, not update
        return false;
      });
      
      if (searchParams.has(navigationSearchParam)) {
        searchParams.delete(navigationSearchParam);
        history.replace(url);
      }
    }
  }, [url, searchParams, entityNumber, entityCurrentIndex, updateFlagNavigationCallback]);
};

export default useEntityNavigationHandle;
